export const MEMBERS_NAMESPACE = `member`;
export const EVENT_NAMESPACE = `event`;
export const PARTICIPANT_NAMESPACE = `participant`;

export const PERSONS_NAMESPACE = `persons`;
export const MEMBER_TYPE_CORRECTION_NAMESPACE = `memberTypeCorrection`;
